import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { AttachmentModel } from '@fc-vehicles/service/attachment-model';

@Component({
  selector: 'fc-media-controls',
  template: `
    <div
      class="flex flex-row items-center justify-between rounded-md px-16 py-12 bg-black/50 text-white"
    >
      <span>{{ currentIndex() + 1 }}/{{ files().length }}</span>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  host: {
    class: 'absolute bottom-30',
  },
})
export class MediaControlsComponent {
  files = input<AttachmentModel[]>();
  currentIndex = input<number>();
}
